import { LangScopeManager, Languages } from '@wicadu/langscope'

const manager = new LangScopeManager([
  Languages.Spanish,
  Languages.English,
  Languages.French,
])

export default manager
